
import {
    SET_DAILY_CRON_LOGS,
} from './types';

import { apiCallV2 } from "../../utils/api";

export const GetDailyCronLogs = (page, count, filter = {}, sort = null) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "daily-cron-log/get",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    dispatch({
        type: SET_DAILY_CRON_LOGS,
        data: {
            list: res.data.dailyCronLogs,
            count: res.data.count[0]["count(*)"]
        }
    })

}
